import React from 'react';
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import SmallTitle from '../Components/SmallTitle';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import SchoolIcon from '@material-ui/icons/School';
import ResumeItem from '../Components/ResumeItem';

function Resume() {
    const briefcase = <BusinessCenterIcon />
    const school = <SchoolIcon />
    return (
        <ResumeStyled>
            <Title title={'Resume'} span={'resume'} />
            <InnerLayout>
                <div className="small-title">
                    <SmallTitle icon={briefcase} title={'Working Experience'} />
                </div>
                <div className="resume-content">
                    <ResumeItem 
                        year={'Dec 2023 - October 2024'} 
                        title={'AI Engineer At Brance'}
                        subTitle={'Hyderabad, India'}
                        text={'Building Machine learning pipelines with fastapi, AWS ,LLms and  langchain'} 
                    />
                <ResumeItem 
                        year={'Jan 2023 - Oct 2024'} 
                        title={'AI Engineer At Genesys'}
                        subTitle={'Hyderabad, India'}
                        text={'AI/ML Engineer at Genesys, Hyderabad. Working on a variety of conversational AI products.'} 
                    />
                    <ResumeItem 
                        year={'AUG 2021 - FEB 2022'} 
                        title={'Junior Backend  Developer At Hexlen'}
                        subTitle={'Christchurch, Canterbury, New Zealand'}
                        text={'Worked as a Full Stack Developer IN HEXLEN using Tech Stack Node js Mongo DB in backend  and  our project involved making an application having both features of ecommerce as well as social media'} 
                    />
                    <ResumeItem 
                        year={'JULY 2021  - OCTOBER 2022'}
                        title={'Backend Developer At Protal'}
                        subTitle={'Vellore,Tamil Nadu, India'}
                        text={'Our work mainly comprised of making Rest Apis with node js and mongo db as per the requirement of Frontend and App Dev Team'} 
                    />
                    <ResumeItem 
                        year={'NOV 2020 - DEC 2020'} 
                        title={'Web Dev Intern At B.R. AGENCIES'}
                        subTitle={'JAIPUR,RAJASTHAN,INDIA'}
                        text={'My work mainly comprised of styling web pages with tech stack react , bootstrap and normal css '} 
                    />
                </div>
                <div className="small-title u-small-title-margin">
                    <SmallTitle icon={school} title={'Educational Qualifications'} />
                </div>
                <div className="resume-content ">
                    <ResumeItem 
                        year={'2019 - 2023'} 
                        title={'Bachelor of Technology , Computer Science'}
                        subTitle={'VELLORE INSTITUTE OF TECHNOLOGY (VIT VELLORE)'}
                        text={'Joined VIT VELLORE in 2019 in BTECH Computer Science branch'} 
                    />
                </div>
            </InnerLayout>
        </ResumeStyled>    
    )
}

const ResumeStyled = styled.section`
    .small-title{
        padding-bottom: 3rem;
    }
    .u-small-title-margin{
        margin-top: 4rem;
    }

    .resume-content{
        border-left: 2px solid var(--border-color);
        overflow-x: auto; /* Enable horizontal scrolling */
    }
`;
export default Resume
